import swaggerClient from "../remote-client";
import Utils from "../Utils";

export default class MembersService {
  fetchMembers(parameters) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityMember.getMembersOfficeWithId(
            parameters,
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(result => result.body.memberList)
      .catch(reason => {
        return Promise.reject({
          type: Utils.errorTypes.STATUS,
          reason
        });
      })
      .finally(() => {});
  }

  fetchMember(officeId, memberFiscalCode) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityMember.getMemberWithVatCodeOfficeWithId(
            {
              id: officeId,
              vatCode: memberFiscalCode
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(result => {
        return result.body.member;
      })
      .catch(reason => {
        console.log(reason);

        return Promise.reject({
          type: Utils.errorTypes.STATUS,
          reason
        });
      });
  }

  fetchMemberAppointments(id, officeId, payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityMember.postAppointmentsMemberWithIdOfficeWithOfficeId(
            { id, officeId },
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(result => {
        return result.body.appointmentList;
      })
      .catch(reason => {
        return Promise.reject({
          type: Utils.errorTypes.STATUS,
          reason
        });
      });
  }
}
